import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  resetData,
  selectId,
  selectLoading,
} from "./settingSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  useForceUpdate,
  paramsSettingNIK,
  paramsSettingPHOTO,
  paramsSettingPrinter,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Mengimpor ikon dari react-icons

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { fetchRole, selectRole } from "../role/roleSlice";

export const SettingCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataRole = useSelector(selectRole);
  const { id } = useParams();
  const forceUpdate = useForceUpdate();
  const [value, setValue] = useState("");

  const paramsId = {
    setting_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await resetData();
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      if (dataId?.setting_value === "ON") {
        setValue(true);
      } else if (dataId?.setting_value === "OFF") {
        setValue(false);
      } else {
        setValue(dataId?.setting_value);
      }
    }
  }, [dataId]);

  const handleSave = async () => {
    const updatedValue =
      value === true ? "ON" : value === false ? "OFF" : value;

    const params = {
      company_setting_id: dataId.company_setting_id,
      setting_id: id,
      company_id: dataId.company_id,
      setting_value: updatedValue,
      setting_name: dataId.setting_name,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeParam = createChangeHandler(setValue);

  const FormGroupWrapper = ({ children }) => (
    <Form.Group as={Row}>
      <Form.Label column sm={3}>
        <b>Value</b>
      </Form.Label>
      <Col sm={6}>{children}</Col>
    </Form.Group>
  );
  const selectConfig = {
    NIK_NPWP_REQUIREMENTS: paramsSettingNIK,
    PRINTER_TYPE: paramsSettingPrinter,
    PHOTO_REMARKS_PENDING_VISIT: paramsSettingPHOTO,
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Setting System"
              : "Edit  Setting System"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Setting Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.setting_alias}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Setting Description</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      as="textarea"
                      value={dataId?.setting_description}
                      disabled
                      rows={5}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                {/* SWITCH ON / OFF */}
                {(dataId?.setting_value === "ON" ||
                  dataId?.setting_value === "OFF") && (
                  <FormGroupWrapper>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      className="mt-3"
                      label={value ? "ON" : "OFF"}
                      checked={value}
                      onChange={(e) => setValue(e.target.checked)}
                    />
                  </FormGroupWrapper>
                )}

                {/* SELECT */}
                {selectConfig[dataId?.setting_name] && (
                  <FormGroupWrapper>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={selectConfig[dataId.setting_name]}
                      value={getValueStatus(
                        value,
                        selectConfig[dataId.setting_name]
                      )}
                      placeholder="Select ..."
                      onChange={handleChangeParam}
                      isClearable
                    />
                  </FormGroupWrapper>
                )}

                {/* TEXT INPUT */}
                {!selectConfig[dataId?.setting_name] &&
                  dataId?.setting_value !== "ON" &&
                  dataId?.setting_value !== "OFF" && (
                    <FormGroupWrapper>
                      <Form.Control
                        type="text"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                    </FormGroupWrapper>
                  )}
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};
